import { Component, h, render } from 'preact';
import { OneBrokerCookieUtil } from '../../../utils/one-broker-cookie';

'hi-results-one-broker-notif'
export class ResultsOneBrokerNotif extends Component <any, any> {
  private oneBrokerCookieUtil: OneBrokerCookieUtil;
  isNotificationRead: boolean;
  node: HTMLElement;

  componentDidMount() {
    this.oneBrokerCookieUtil = new OneBrokerCookieUtil();
    this.isNotificationRead = this.oneBrokerCookieUtil.isNotificationRead();
    
    if (this.isNotificationRead) {
      render(null, this.node, this.node);
    }
  }

  onButtonClicked = e => {
    this.oneBrokerCookieUtil.setNotificationStatus();

    this.isNotificationRead = this.oneBrokerCookieUtil.isNotificationRead();
    
    if (this.isNotificationRead) {
      render(null, this.node, this.node);
    }
  }

  isOnMobile() {
    return window && window.innerWidth < 576;
  }

  render() {
    if (!this.isOnMobile()) {
      return (
        <div class="hi-results-one-broker-notif__container" ref={node => this.node = node}>
          <div class="hi-results-one-broker-notif__content container-fluid">
            <h3 class="hi-results-one-broker-notif__content__heading mt-2">
              One broker for all your chosen properties
            </h3>
            <p class="hi-results-one-broker-notif__p">
              For all of your chosen properties, you'll have only one 
              broker to assist you all throughout. Just add the properties 
              to your viewing list. Here's how: 
            </p>
  
            <img class="mb-4 img-fluid"
              src="https://hoppler-inc.imgix.net/hoppler/pages/static/sample-chosen-property-edited-001.png" 
              alt="sample-set-viewing-list"/>
  
            <div class="row justify-content-end d-none d-md-flex">
              <div class="col-md-4">
                <button class="btn btn-secondary w-100"
                  onClick={ this.onButtonClicked }>
                  Got it!
                </button>
              </div>
            </div>
  
            <div class="row justify-content-center d-md-none">
              <div class="col-10">
                <button class="btn btn-secondary w-100"
                  onClick={ this.onButtonClicked }>
                  Got it!
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

}